import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "store/user/selectors";
import { setSelectedLevel } from "store/game";
import Levels from "pages/home/Levels";

export default function Setup() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(selectUser);

  if (!user.username) {
    return <Navigate to="/" />;
  }

  return (
    <div className="flex flex-col  flex-grow fill-slate-100 pt-4">
      <Levels
        gridLayout
        onSelect={(level) => {
          dispatch(setSelectedLevel(level));
          navigate("/load", {
            state: { level },
          });
        }}
      />
    </div>
  );
}
